import { NAVIGATION, RESET_SERVICE } from '@constants/navigation';
import store from '@store';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        description: 'Lists all the services for an admin.',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },
    {
        path: '/login',
        name: 'Login',
        description: 'Login page.',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/password-lost',
        name: 'Lost password',
        description: 'Password lost page.',
        component: () => import(/* webpackChunkName: "password lost" */ '../views/passwordLost/Home.vue')
    },
    {
        path: '/password-lost/secret-questions',
        name: 'Secret questions',
        description: 'Secret questions page.',
        component: () => import(/* webpackChunkName: "password lost - secret questions" */ '../views/passwordLost/Questions.vue')
    },
    {
        path: '/password-lost/change',
        name: 'Change password',
        description: 'Change password page.',
        component: () => import(/* webpackChunkName: "password lost - change" */ '../views/passwordLost/Change.vue')
    },
    {
        path: '/password-lost/changed',
        name: 'Changed password',
        description: 'Changed password page.',
        component: () => import(/* webpackChunkName: "password lost - changed" */ '../views/passwordLost/Changed.vue')
    },
    {
        path: '/login/sso',
        name: 'LoginSSO',
        description: 'Login to the SSO.',
        beforeEnter() {
            location.href = '/api/v1/auth/security/ssoLogin';
        }
    },
    {
        path: '/logout/ldap',
        name: 'LogoutLDAP',
        description: 'Logout of the LDAP.',
        beforeEnter() {
            location.href = '/api/v1/auth/security/ldap/logout';
        }
    },
    {
        path: '/documentation',
        name: 'Documentation',
        description: 'Documentation of the routes pages.',
        component: () => import(/* webpackChunkName: "documentation" */ '../views/Documentation.vue')
    },
    {
        path: '/backoffice',
        name: 'Backoffice',
        description: 'Configure data.',
        component: () => import(/* webpackChunkName: "documentation" */ '../views/backoffice/Home.vue')
    },
    {
        path: '/accMgmt',
        description: 'Account management',
        component: () => import(/* webpackChunkName: "User information" */ '../views/passaccount/Home.vue'),
        children: [
            {
                name: 'Account management',
                path: '',
                component: () => import(/* webpackChunkName: "User information" */ '../views/passaccount/UserInfo.vue')
            },
            {
                path: 'password',
                component: () => import(/* webpackChunkName: "My password" */ '../views/passaccount/Password.vue')
            },
            {
                path: 'secretquestions',
                component: () => import(/* webpackChunkName: "My secret questions" */ '../views/passaccount/SecretQuestions.vue')
            }
        ]
    },
    {
        path: '/accMgmt/Configuration/:UUID',
        description: 'Account management configuration',
        name: 'Account management configuration',
        component: () => import(/* webpackChunkName: "User information - configuration" */ '../views/passaccount/Configuration.vue')
    },
    {
        path: '/accMgmt/pwdConfiguration/:UUID',
        description: 'PWD configuration',
        name: 'PWD configuration',
        component: () =>
            import(/* webpackChunkName: "User information - configuration" */ '../views/passaccount/PwdConfiguration.vue')
    },
    // {
    // path: '/administration',
    // description: 'Administration pages.'
    //component: () => import(/* webpackChunkName: "administration" */ '../views/Administration/Home.vue'),
    // children: [
    //     {
    //         name: 'Administration',
    //         path: '',
    //         component: () => import(/* webpackChunkName: "ldap" */ '../views/Administration/tabs/ldap.vue')
    //     },
    //     {
    //         path: 'secret-questions',
    //         component: () => import(/* webpackChunkName: "secret questions" */ '../views/Administration/tabs/question.vue')
    //     },
    //     {
    //         path: 'frequency',
    //         component: () => import(/* webpackChunkName: "frequency" */ '../views/Administration/tabs/frequency.vue')
    //     },
    //     {
    //         path: 'autorizations',
    //         component: () => import(/* webpackChunkName: "autorizations" */ '../views/Administration/tabs/autorisations.vue')
    //     },
    //     {
    //         path: 'mails-notifications',
    //         component: () => import(/* webpackChunkName: "mails notifications" */ '../views/Administration/tabs/emails.vue')
    //     },
    //     {
    //         path: 'web-text',
    //         component: () => import(/* webpackChunkName: "web text" */ '../views/Administration/tabs/texts.vue')
    //     },
    //     {
    //         path: 'users-guid',
    //         component: () => import(/* webpackChunkName: "users guid" */ '../views/Administration/tabs/guides.vue')
    //     },
    //     {
    //         path: 'pass-lookup',
    //         component: () => import(/* webpackChunkName: "pass lookup" */ '../views/Administration/tabs/lookup.vue')
    //     },
    //     {
    //         path: 'pwd-config',
    //         component: () => import(/* webpackChunkName: "pwd config" */ '../views/Administration/tabs/pwdConfig.vue')
    //     }
    // ]
    //   },
    {
        path: '/informations/legals',
        name: 'Footer - legals',
        description: 'Legals informations',
        component: () => import(/* webpackChunkName: "informations/legals" */ '../views/footer/Legals.vue')
    },
    {
        path: '/informations/privacyPolicy',
        name: 'Footer - privacyPolicy',
        description: 'privacyPolicy',
        component: () => import(/* webpackChunkName: "informations/privacyPolicy" */ '../views/footer/privacyPolicy.vue')
    },
    {
        path: '*',
        redirect: '/'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        store.commit(`${NAVIGATION}/${RESET_SERVICE}`);
    }
    next();
});

export default router;
